import { render, staticRenderFns } from "./_ConfirmationList.vue?vue&type=template&id=2b4c4dfa&scoped=true&"
import script from "./_ConfirmationList.vue?vue&type=script&lang=js&"
export * from "./_ConfirmationList.vue?vue&type=script&lang=js&"
import style0 from "./_ConfirmationList.vue?vue&type=style&index=0&id=2b4c4dfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c4dfa",
  null
  
)

export default component.exports